<template>
    <loading v-if="loading" />
    <div v-else>
        <div v-if="$mq === 'sm' || $mq === 'md'">
            <create-ticket-xs />
        </div>
        <div v-else class="create-tickets-outer-container-xl">
            <div class="create-tickets-left-side-container-xl">
                <ExpandedSidebarXl />
            </div>
            <div class="create-tickets-right-side-container-xl">
                <header-xl title="Create Ticket" subtitle="Get Help" />
                <create-ticket-xl />
            </div>
        </div>
    </div>
</template>

<script>
import HeaderXl from '@/components/header/TheHeaderXl.vue';
import ExpandedSidebarXl from '@/components/sidebar/ExpandedSidebarXl.vue';
import Loading from '@/components/loading/Loading.vue';
import CreateTicketXs from './pages/CreateTicketXs.vue';
import CreateTicketXl from './pages/CreateTicketXl.vue';
import { mapState } from 'vuex';

export default {
    components: { HeaderXl, ExpandedSidebarXl, Loading, CreateTicketXs, CreateTicketXl },
    computed: {
        ...mapState(['createTicketStore']),
        loading() {
            return this.createTicketStore.loading;
        },
    },
    created() {
        this.$store.dispatch('createTicketStore/getCategories');
        this.$store.commit('setHeaderTitle', 'Create Ticket');
    },
};
</script>

<style lang="scss" scoped>
.create-tickets {
    &-outer-container-xl {
        height: 100vh;
        display: grid;
        grid-template-columns: 168px calc(100% - 196px);
        column-gap: 32px;
        width: 91vw;
        max-width: 1311px;
        margin: 0 auto;
    }
    &-right-side {
        &-container-xl {
            height: calc(100% - 16px);
        }
    }
    &-left-side {
        &-container-xl {
            width: 168px;
            height: calc(100vh - 32px);
        }
    }
}
</style>
